module.exports = __webpack_public_path__ + "img/img22.f0b248c3.png";